import { Button as UIButton } from "@webmotors/eleanor-ui";
import type {
  AnchorHTMLAttributes,
  ButtonHTMLAttributes,
  ReactNode,
} from "react";

type Variant =
  | "primary"
  | "secondary"
  | "situational"
  | "tertiary"
  | "tertiary-situational"
  | "title"
  | "title-situational";

type State = "active" | "disabled";
type Size = "large" | "medium" | "small";

export type BaseButtonProps = {
  children: ReactNode;
  className?: string;
  isDestructive?: boolean;
  isLoading?: boolean;
  isOnlyIcon?: boolean;
  size?: Size;
  state?: State;
  variant?: Variant;
  dataQA?: string;
};

export type ButtonProps = BaseButtonProps &
  ButtonHTMLAttributes<HTMLButtonElement> & {
    tag?: "button";
  };

export type AnchorProps = BaseButtonProps &
  AnchorHTMLAttributes<HTMLAnchorElement> & {
    tag: "a";
  };

export type ButtonComponentProps = ButtonProps | AnchorProps;

export function Button({ dataQA, ...props }: ButtonComponentProps) {
  return (
    <UIButton data-qa={dataQA} {...props}>
      {props.children}
    </UIButton>
  );
}
